import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { DynamicItemBaseComponent } from '@ups/xplat/dynamic-render';
import { SecurityService } from '@ups/security';
import { SecurityConstants } from '@ups/security-constants';

@Component({
  selector: 'ups-dynamic-last-modified',
  template: `
    @if (canView) {
      <p>
        Last Modified
        {{
          dynamicService?.activeFormResponse?.modifiedDate + 'Z'
            | date: 'M/d/yy, h:mm a' : 'CST'
        }}
        (CST) by
        {{ dynamicService?.activeFormResponse?.modifiedByName }}
      </p>
    }
  `,
  // WI 35909 (S2): the template reads dynamicService.activeFormResponse, which the service
  // replaces after first render (response load, reset); its change stream marks this view.
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DynamicLastModifiedComponent
  extends DynamicItemBaseComponent
  implements OnInit
{
  securityConstants = SecurityConstants;
  securityService = inject(SecurityService);
  canView = false;

  ngOnInit(): void {
    // overrides the base ngOnInit without super, so wire the base's in-place config-write mark
    this.markOnInPlaceConfigWrites();
    this.canView = this.securityService.getFeatureById(
      SecurityConstants.safety_2_0_forms_lastmodifieddetails
    ).viewFeature;
    this.dynamicService?.attachmentState.changed$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.cdr?.markForCheck());
  }
}
